module.exports = __webpack_public_path__ + "public/images/neurodiverse.74f76b269975a950247d6eccc49c1983.png";